module.exports = __webpack_public_path__ + "static/media/upload-white.f2463ed3.svg";